<template>
    <div class=" w100 pt20 pb20 bg-w display-box subject topic-dl">
        <div class="module-items w120 mc pt20 pb20">
            <div class="centerDL">
                <div class="w100 font-24 tx-c dl-left">办事服务  <span style="color: #98adc3;font-size: 12px">/Services</span></div>
                <el-row style="display: flex;align-items: center">
                    <el-col :span="24">
                        <el-tabs v-model="activeValue" type="card" @tab-click="handleClick">
                            <el-tab-pane v-for="(e, i) in titleData" :label="e.name" :key="i" :name="e.id"></el-tab-pane>
                        </el-tabs>
                    </el-col>
                </el-row>
                <div class="dl-more" style="top: 0;">
                    <el-input v-model="servicesInput"  placeholder="请输入内容"><el-button @click="getTitleData" slot="append" icon="el-icon-search"></el-button></el-input>
                </div>
            </div>
            <div v-if="itemData" class="centCla">
                <div class="serve-item" v-for="(e, i) in itemData" :key="i" @click="goServe(e)">
                    <div class="itemTypeCla">{{activeName}}</div>
                    <div class="serve-logo">
                        <img :src="e.icon_url" alt="">
                    </div>
                    <div class="serve-name ellipsis">{{e.server_name}}</div>
                    <div class="rateClass">
                        <el-rate
                                v-model="value"
                                disabled
                                text-color="#ff9900">
                        </el-rate>
                        <span>16人收藏</span>
                    </div>
                </div>
            </div>
        </div>
        <IframeView ref="IframeView"></IframeView>
        <queryTypeModal
                :data="dataModal"
                @close="onDialogClose"/>
    </div>
</template>

<script>
    import {getTopicList, getTopicInfo} from '@/api/managementCenter/specialManage'
    import queryTypeModal from "@/components/common/queryTypeModal.vue";
    import IframeView from "@/components/public/IframeView.vue";
    import { bpmnStartProcess} from '@/api/bpmnApi/bpmn';
    export default {
        name: "topicdl",
        components: {queryTypeModal, IframeView},
        props: ['moduleData'],
        data() {
            return {
                baseUrl: process.env.BASE_URL,
                activeValue:'',
                titleData:[],
                itemData:[],
                servicesInput: '',
                activeIndex: 0,
                activeName: '',
                value: 5,
                middlePage:JSON.parse(window.sessionStorage.getItem('setConfig')).middlePage,
                dataModal:{
                    show: false,
                    data:{},
                },
            };
        },
        created(){
            // this.activeValue = this.moduleData.cardModules[0].data[0].topicId
            // this.activeName = this.moduleData.cardModules[0].data[0].topicName
            this.getTitleData()
        },
        computed: {
        },
        methods: {
            getTitleData(){
                let param = {
                    current:1,
                    size:100,
                    name: this.servicesInput || ''
                }
                getTopicList(param).then(res =>{
                    this.titleData = res.data.data.records
                    this.activeValue = this.titleData[0].id
                    this.activeName = this.titleData[0].name
                    this.handleClick()
                })
            },
            handleWidth(col){
                switch (col) {
                    case 1:
                        return '100%'
                    case 2:
                        return '50%'
                    case 3:
                        return '33.3%'
                    case 4:
                        return '25%'
                    case 5:
                        return '20%'
                    case 6:
                        return '16.6%'
                    default:
                        return '50%'
                }
            },
            handleClick(){
                getTopicInfo(this.activeValue).then(res =>{
                    this.itemData = res.data.data.selectedServes
                })
            },
            goServe(row){
                if(row.serveType == '0' && row.queryType == '2'){
                    this.dataModal.show = true
                    this.dataModal.data = row
                }
                if(row.serveType == '0' && row.queryType == '1'){
                    this.$refs.IframeView.showView(row.queryPcUrl, row.taskInstId);
                }
                if(row.serveType == '1' && row.queryType == '0'){
                    if(!this.middlePage){
                        this.HandleApply(row)
                    }else {
                        let routeData = this.$router.resolve({
                            path: `/ServeCenterDetail`,
                            query:{id:row.serveId}
                        });
                        window.open(routeData.href);
                    }
                }
            },
            onDialogClose() {
                this.dataModal.show = false
            },
            HandleApply(item){
                let processDefId=item.processDefId;
                bpmnStartProcess({processDefId}).then(({data})=>{
                    if(data.code==0){
                        window.sessionStorage.setItem("processInstId", data.data.processInstId);
                        this.$refs.IframeView.showView(data.data.url, data.data.taskInstId);
                    }else{
                        this.$message.warning(data.msg||'流程系统业务忙，请刷新或者重新操作');
                    }

                }).catch(err=>{
                    this.$message.error("服务异常" );
                })
            },
        },
        watch: {},
        filters: {}
    }
</script>

<style lang="less">


</style>